import { render, staticRenderFns } from "./datasource-detail.vue?vue&type=template&id=1acc2d18&scoped=true&"
import script from "./datasource-detail.vue?vue&type=script&lang=ts&"
export * from "./datasource-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc2d18",
  null
  
)

export default component.exports